export function decodeHtml(str: string) {
  return str.replace(/(&#([\d\w]+);)/gi, (_match, _capture, charCode) =>
    String.fromCharCode(
      charCode.startsWith('x')
        ? parseInt(charCode.substr(1), 16)
        : parseInt(charCode, 10)
    )
  )
}
